import makeStyles from "@mui/styles/makeStyles";
export default makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        accountEmail: {
            textTransform: "lowercase",
            paddingLeft: spacing(0.5),
        },
    });
});
//# sourceMappingURL=useStyles.js.map